import { Map } from 'immutable';

export default Map({
  loading: false,
  token: '',
  redirectUrl: '',
  error: null,
  ESAuthError: '',
  ESAuthErrorId: '',
  userCreated: false,
  checkSuccess: false,
});
